import { setAnalytics, isDuplicatePageError } from '../../../thd-analytics-utils';
import {
  ACCOUNT,
  ADD_MANAGE_USERS_PAGE,
  ADD_MANAGE_USERS_PAGE_TYPE
} from '../../../constants';

export function addManageUsersPage() {
  window.LIFE_CYCLE_EVENT_BUS.lifeCycle.on('manage-users.page-load', () => {
    digitalData.page = {
      pageInfo: {
        pageName: ADD_MANAGE_USERS_PAGE,
        pageType: ADD_MANAGE_USERS_PAGE_TYPE
      },
      category: {
        primaryCategory: ACCOUNT,
        subCategory1: ADD_MANAGE_USERS_PAGE,
        subCategory2: ADD_MANAGE_USERS_PAGE
      }
    };

    setAnalytics(digitalData);
  });

  // setUserPageErrorAnalytics (src/utils/add-manage-user-analytics.ts)
  window.LIFE_CYCLE_EVENT_BUS.lifeCycle.on('manage-users.page-error', ({ output }) => {
    const {
      type = 'error',
      displayType = 'page',
      pageSection = '',
      message = '',
      code = ''
    } = output || {};

    const pageError = {
      type,
      displayType,
      pageSection,
      message,
      code
    };

    digitalData.page = digitalData.page || {};
    digitalData.page.error = digitalData.page.error || [];
    if (!isDuplicatePageError(digitalData, pageError)) {
      digitalData.page.error.push(pageError);
    }
  });
}
